export default "__VITE_ASSET__BVuZV4UH__"